import React, { useState, useEffect, useRef } from 'react';
import { intialLoading, setIndex } from '../../store/screentransistion/actions';
import { saveUserDetails } from '../../store/trackinguser/actions';
import Layout from '../common/layoutred';
import SubmitButtonImg from '../../assets/images/backgrounds/submit_button.png';
import { fetchShuffle } from '../../store/shuffledata/operations';
import { Alert } from '@material-ui/lab';
import { isAndroid } from 'react-device-detect';
import './style.scss';
import fullScreen from '../../utils/fullScreen';
import { connect } from 'react-redux';
import {
  toggleMusic,
  toggleVoiceOver,
} from '../../store/screentransistion/actions';
import music from '../../assets/audio/BGMusic.mp3';
import PlayMusic from '../../utils/playMusic';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import {termsEn} from './terms'
const Registration = ({
  fetchShuffle,
  shuffleData,
  progress,
  languages,
  zones,
  saveUserDetails,
  audio,
  intialLoading,
  setIndex,
  gameSessionId,
  language,
  toggleMusic,
  toggleVoiceOver,
  trackingUser
}) => {
  const [india] = zones;
  const [english] = languages;

  const [data, setData] = useState({
    zone: india._id,
    lang: english.value,
    number: '',
  });

  const activate = fullScreen();

  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState('paper');
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState('Please enter valid details');
  const [isChecked, setIsChecked] = useState(false)
  const descriptionElementRef = useRef(null);

  useEffect(() => {
    const path = window.location.pathname;
    const mobileNumber = path.replace('/', '');
    setData({ ...data, number: mobileNumber });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingUser]);

  
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleCheckbox = (event) => {
    setIsChecked(!isChecked)
    if (event.target.checked) {
      setError(false)
      setMsg("")
    }
  }

  const toggleCheckbox = () => {
    if (!isChecked) {
      setError(false)
      setMsg("")
    }
    setIsChecked(!isChecked)
  }
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    const rExp = /^[0-9\b]+$/;

    if (name === 'number') {
      if (rExp.test(event.target.value)) {
        if (event.target.value.length <= 15) {
          setData({ ...data, [name]: value });
          setError(false);
        } else {
          setError(true);
          setMsg('Maximum 15 numbers allowed');
          return;
        }
      } else {
        setData({ ...data, [name]: '' });
        setError(true);
        setMsg('Please enter a number');
        return;
      }
    }

    setData({ ...data, [name]: value });
  };

  const register = (event) => {
    event.preventDefault();
    if (data.number.length < 0) {
      setError(true);
      setMsg('Please enter valid number');
      return;
    }
    if (data.number.length > 0 && data.lang && data.zone) {
      fetchShuffle(
        [data.lang, data.number],
        () => {
          toggleVoiceOver(false);
          toggleMusic(true);
          const audioRef = PlayMusic(music);
          audioRef.pause();

          intialLoading();
          setIndex(4); // skip intro, help, avatar selection, and level one screens - jump directly to the game
          saveUserDetails(data);
          if (isAndroid) {
            activate();
          }
        },
        (err) => {
          setError(true);
          setMsg('NetWork Failed Please Check Network Connection');
        }
      );
    } else {
      setError(true);
      setMsg('All fields are required');
    }
  };

  return (
    <>
      <Layout>
        <div className="registration__container">
          <form onSubmit={register}>
            <div className="form__control">
              <select name="lang" value={data.lang} onChange={handleChange}>
                {languages
                  ? languages.map((lan) => (
                      <option key={lan.value} value={lan.value}>
                        {lan.language}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            <div className="terms__condition">
              <div> <input type="checkbox" checked={isChecked} onChange={handleCheckbox} 
              style={{ verticalAlign: 'middle', transform: "scale(1.7)" }} />
                <Button style={{ marginTop: '1px' }}>
                  <div className="termstext" >
                    <h2 style={{ color: 'white' }}>
                    <span onClick={toggleCheckbox}>I agree with </span>
                    <span onClick={handleClickOpen('paper')} style={{ color: 'black', textDecoration: "underline" }}>
                    Terms and Conditions</span>
                    </h2>
                  </div>
                </Button>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  scroll={scroll}
                  aria-labelledby="scroll-dialog-title"
                  aria-describedby="scroll-dialog-description"
                >
                  <DialogTitle id="scroll-dialog-title">
                    Terms and Conditions
                  </DialogTitle>
                  <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                      id="scroll-dialog-description"
                      ref={descriptionElementRef}
                      tabIndex={-1}
                    >
                      {termsEn}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
            <div
              type="submit"
              className="form__control start_button"
              onClick={register}
            >
              <img src={SubmitButtonImg} alt="start_image" />
              <div type="submit" className="button__text">
                Start
              </div>
            </div>
            <div className="form__control error__msg">
              {error ? (
                <Alert severity="error">
                  <h3>{msg}</h3>
                </Alert>
              ) : null}
            </div>
          </form>
        </div>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    shuffleData: state.shuffleData,
    progress: state.progress,
    languages: state.intialize.languages,
    zones: state.intialize.zones,
    audio: state.shuffleData,
    language: state.trackingUser.userDeatils,
  };
};

const mapDispathToProps = (dispatch) => {
  return {
    fetchShuffle: (language, success, failure) =>
      dispatch(fetchShuffle(language, success, failure)),
    saveUserDetails: (details) => dispatch(saveUserDetails(details)),
    intialLoading: () => dispatch(intialLoading()),
    setIndex: (index) => dispatch(setIndex(index)),
    toggleMusic: (toggle) => dispatch(toggleMusic(toggle)),
    toggleVoiceOver: (toggle) => dispatch(toggleVoiceOver(toggle)),
  };
};

export default connect(mapStateToProps, mapDispathToProps)(Registration);
